module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgB7ZYxDoAgDEWrceASDl7BkdGDO7p6BAcOIQOD6OBQUigTMf6XdCj5IT8h/Jbo73QKzcJ6H2sTtDaWYWcrZeipMTAwKDSe9WeFFgBQRBPFE+tDLCdoR0q/9kEZNDnADfiCAVNjAFH8iVnA3zBktE55JwDgRTMLLOvvlWwXtDOlUSyt8A+aP2tIj6nUI4rbGwAXgqgR5+hgyQYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/test/drag_icon_active.png
// module id = dTI7
// module chunks = 4